import React from "react";
import GetOtpBtn from "../auth/GetOtpBtn";
import layoutStyles from "../layout/css/settingLayout.module.css";

/**
 * Reusable modal body component for OTP-protected settings forms (e.g. API Keys, IP Whitelisting).
 */
const OtpModalForm = ({
  subtext,
  customField,
  otp = "",
  setOtp,
  otpLoading = false,
  otpTimer = 0,
  onGetOtp,
  onSubmit,
  loading = false,
  submitText = "Confirm & Submit",
  submitLoadingText = "Submitting...",
  otpLabel = "OTP Verification Code",
  otpPlaceholder = "Enter 6-digit OTP",
}) => {
  return (
    <div>
      {subtext && <p className={layoutStyles.modalSubtext}>{subtext}</p>}

      {/* Render optional custom field (e.g. IP Address input) */}
      {customField}

      {/* OTP Field with Resend/Get OTP Button */}
      <div className={layoutStyles.formGroup}>
        <label className={layoutStyles.formLabel}>{otpLabel}</label>
        <div className={layoutStyles.otpRow}>
          <input
            type="text"
            className={layoutStyles.customInput}
            placeholder={otpPlaceholder}
            value={otp}
            onChange={(e) => setOtp && setOtp(e.target.value)}
          />
          <GetOtpBtn
            onClick={onGetOtp}
            loading={otpLoading}
            timer={otpTimer}
            className={layoutStyles.btnOtp}
          />
        </div>
      </div>

      {/* Submit Button */}
      <button
        type="button"
        className={layoutStyles.btnSubmit}
        onClick={onSubmit}
        disabled={loading}
      >
        {loading ? submitLoadingText : submitText}
      </button>
    </div>
  );
};

export default OtpModalForm;
